import { render } from "./CinemaList.vue?vue&type=template&id=fb5b7c0e"
import script from "./CinemaList.vue?vue&type=script&lang=js"
export * from "./CinemaList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__